import { Navigate, Route, Routes as RoutesContainer, useLocation, useNavigate } from "react-router-dom";
import { ThrowNotFound } from "./ErrorBoundary";
import { Signin } from "../pages/Signin";
import { GerantDetail, GerantsList } from "../pages/crud/Gerants";
import { UserDetail, UsersList } from "../pages/crud/Users";
import { ChangePassword } from "../pages/ChangePassword";
import { ClientDetail, ClientsList } from "../pages/crud/Clients";
import { ContactDetail, ContactsList } from "../pages/crud/Contacts";
import { ChantierDetail, ChantiersList } from "../pages/crud/Chantiers";
import { CodesDetail } from "../pages/crud/Codes";
import { CodeSortiePoubellesDetail, CodesSortiePoubellesList } from "../pages/crud/CodesSortiePoubelles";
import { FourniseurDetail, FourniseursList } from "../pages/crud/Fourniseurs";
import { HistoriqueDetail } from "../pages/crud/Historique";
import { PlainteDetail } from "../pages/crud/Plaintes";
import { OffreDetail, OffresList } from "../pages/crud/Offres";
import { OffreDetailDetail } from "../pages/crud/OffresDetail";
import { OffreFrequencesList, OffreFrequenceDetail } from "../pages/crud/OffreFrequences";
import { OffreSectionDetail, OffreSectionsList } from "../pages/crud/OffreSections";
import { OffreTacheDetail, OffreTachesList } from "../pages/crud/OffreTaches";
import { OffreMaterielDetail, OffreMaterielsList } from "../pages/crud/OffreMateriel";
import { OffreMaterielDetailDetail } from "../pages/crud/OffreMaterielDetail";
import { OffreModeleDetail, OffreModelesList } from "../pages/crud/OffreModele";
import { OffreModeleDetailDetail } from "../pages/crud/OffreModeleDetail";
import { ArticleDetail, ArticlesList } from "../pages/crud/Articles";
import { FactureDetail, FacturesControle, FacturesList } from "../pages/crud/Factures";
import { FacturesDetailDetail } from "../pages/crud/FacturesDetail";
import { NotesDeCreditDetail, NotesDeCreditList } from "../pages/crud/NotesDeCredit";
import { NotesDeCreditDetailDetail } from "../pages/crud/NotesDeCreditDetail";
import { PersonnelControle, PersonnelDetail, PersonnelList } from "../pages/crud/Personnel";
import { TempsDetail } from "../pages/crud/Temps";
import { PrixChantierDetail } from "../pages/crud/PrixChantiers";
import { SocieteDetail, SocietesList } from "../pages/crud/Societes";
import { MaterielDetail } from "../pages/crud/Materiel";
import { TypeDePlainteDetail, TypeDePlaintesList } from "../pages/crud/TypeDePlaintes";
import { ChantierConcurrentDetail, ChantiersConcurrentsList } from "../pages/crud/ChantiersConcurrents";
import { FrequencesDetail, FrequencesList } from "../pages/crud/Frequences";
import { VerreFrequenceDetail, VerreFrequencesList } from "../pages/crud/VerreFrequence";
import { FacturesAchatDetail, FacturesAchatList } from "../pages/crud/FacturesAchat";
import { FacturesAchatDetailDetail } from "../pages/crud/FacturesAchatDetail";
import { useEffect } from "react";
import { TravauxPonctuelsDetail, TravauxPonctuelsList } from "../pages/crud/TravauxPonctuels";

export function Routes() {
    const { pathname, search } = useLocation()
    const navigate = useNavigate()
    useEffect(() => {
        if (!pathname.endsWith('/')) navigate(pathname + '/' + search, { replace: true })
    }, [pathname])
    if (!pathname.endsWith('/')) return null

    return <RoutesContainer>
        <Route index element={<Navigate to="/gerants" />} />
        <Route path="/articles" element={<ArticlesList />} />
        <Route path="/articles/:id" element={<ArticleDetail />} />
        <Route path="/articles/:relatedId/historique" element={<Navigate to="./.." />} />
        <Route path="/articles/:relatedId/historique/:id" element={<HistoriqueDetail relation="articleId" />} />
        <Route path="/articles/:relatedId/materiel" element={<Navigate to="./.." />} />
        <Route path="/articles/:relatedId/materiel/:id" element={<MaterielDetail relation="articleId" />} />
        <Route path="/clients" element={<ClientsList />} />
        <Route path="/clients/:id" element={<ClientDetail />} />
        <Route path="/clients/:relatedId/contacts" element={<Navigate to="./.." />} />
        <Route path="/clients/:relatedId/contacts/:id" element={<ContactDetail relation="clientId" />} />
        <Route path="/clients/:relatedId/plaintes" element={<Navigate to="./.." />} />
        <Route path="/clients/:relatedId/plaintes/:id" element={<PlainteDetail relation="clientId" />} />
        <Route path="/clients/:relatedId/historique" element={<Navigate to="./.." />} />
        <Route path="/clients/:relatedId/historique/:id" element={<HistoriqueDetail relation="clientId" />} />
        <Route path="/chantiers" element={<ChantiersList />} />
        <Route path="/chantiers/:id" element={<ChantierDetail />} />
        <Route path="/chantiers/:relatedId/codes" element={<Navigate to="./.." />} />
        <Route path="/chantiers/:relatedId/codes/:id" element={<CodesDetail relation="chantierId" />} />
        <Route path="/chantiers/:relatedId/materiel" element={<Navigate to="./.." />} />
        <Route path="/chantiers/:relatedId/materiel/:id" element={<MaterielDetail relation="chantierId" chantier />} />
        <Route path="/chantiers/:relatedId/prixChantiers" element={<Navigate to="./.." />} />
        <Route path="/chantiers/:relatedId/prixChantiers/:id" element={<PrixChantierDetail relation="chantierId" />} />
        <Route path="/chantiers/:relatedId/temps" element={<Navigate to="./.." />} />
        <Route path="/chantiers/:relatedId/temps/:id" element={<TempsDetail relation="chantierId" />} />
        <Route path="/chantiersConcurrents" element={<ChantiersConcurrentsList />} />
        <Route path="/chantiersConcurrents/:id" element={<ChantierConcurrentDetail />} />
        <Route path="/codesSortiePoubelles" element={<CodesSortiePoubellesList />} />
        <Route path="/codesSortiePoubelles/:id" element={<CodeSortiePoubellesDetail />} />
        <Route path="/contacts" element={<ContactsList />} />
        <Route path="/contacts/:id" element={<ContactDetail />} />
        <Route path="/factures" element={<FacturesList />} />
        <Route path="/factures/controle" element={<FacturesControle />} />
        <Route path="/factures/:id" element={<FactureDetail />} />
        <Route path="/factures/:relatedId/facturesDetail" element={<Navigate to="./.." />} />
        <Route path="/factures/:relatedId/facturesDetail/:id" element={<FacturesDetailDetail relation="factureId" />} />
        <Route path="/facturesAchat" element={<FacturesAchatList />} />
        <Route path="/facturesAchat/:id" element={<FacturesAchatDetail />} />
        <Route path="/facturesAchat/:relatedId/facturesAchatDetail" element={<Navigate to="./.." />} />
        <Route path="/facturesAchat/:relatedId/facturesAchatDetail/:id" element={<FacturesAchatDetailDetail relation="factureAchatId" />} />
        <Route path="/fournisseurs" element={<FourniseursList />} />
        <Route path="/fournisseurs/:id" element={<FourniseurDetail />} />
        <Route path="/fournisseurs/:relatedId/historique" element={<Navigate to="./.." />} />
        <Route path="/fournisseurs/:relatedId/historique/:id" element={<HistoriqueDetail relation="fournisseurId" />} />
        <Route path="/frequences" element={<FrequencesList />} />
        <Route path="/frequences/:id" element={<FrequencesDetail />} />
        <Route path="/gerants" element={<GerantsList />} />
        <Route path="/gerants/:id" element={<GerantDetail />} />
        <Route path="/gerants/:relatedId/historique" element={<Navigate to="./.." />} />
        <Route path="/gerants/:relatedId/historique/:id" element={<HistoriqueDetail relation="gerantId" />} />
        <Route path="/gerants/:relatedId/contacts" element={<Navigate to="./.." />} />
        <Route path="/gerants/:relatedId/contacts/:id" element={<ContactDetail relation="gerantId" />} />
        <Route path="/notesDeCredit" element={<NotesDeCreditList />} />
        <Route path="/notesDeCredit/:id" element={<NotesDeCreditDetail />} />
        <Route path="/notesDeCredit/:relatedId/notesDeCreditDetail" element={<Navigate to="./.." />} />
        <Route path="/notesDeCredit/:relatedId/notesDeCreditDetail/:id" element={<NotesDeCreditDetailDetail relation="notesDeCreditId" />} />
        <Route path="/offres" element={<OffresList />} />
        <Route path="/offres/:id" element={<OffreDetail />} />
        <Route path="/offres/:relatedId/offresDetail" element={<Navigate to="./.." />} />
        <Route path="/offres/:relatedId/offresDetail/:id" element={<OffreDetailDetail relation="offreId" />} />
        <Route path="/offres/:relatedId/historique" element={<Navigate to="./.." />} />
        <Route path="/offres/:relatedId/historique/:id" element={<HistoriqueDetail relation="offreId" />} />
        <Route path="/offres/:relatedId/contacts" element={<Navigate to="./.." />} />
        <Route path="/offres/:relatedId/contacts/:id" element={<ContactDetail relation="offreId" />} />
        <Route path="/offreMateriel" element={<OffreMaterielsList />} />
        <Route path="/offreMateriel/:id" element={<OffreMaterielDetail />} />
        <Route path="/offreMateriel/:relatedId/offreMaterielDetail" element={<Navigate to="./.." />} />
        <Route path="/offreMateriel/:relatedId/offreMaterielDetail/:id" element={<OffreMaterielDetailDetail relation="offreMaterielId" />} />
        <Route path="/offreMateriel/:relatedId/historique" element={<Navigate to="./.." />} />
        <Route path="/offreMateriel/:relatedId/historique/:id" element={<HistoriqueDetail relation="offreMaterielId" />} />
        <Route path="/offreModele" element={<OffreModelesList />} />
        <Route path="/offreModele/:id" element={<OffreModeleDetail />} />
        <Route path="/offreModele/:relatedId/offreModeleDetail" element={<Navigate to="./.." />} />
        <Route path="/offreModele/:relatedId/offreModeleDetail/:id" element={<OffreModeleDetailDetail relation="offreModeleId" />} />
        <Route path="/offreFrequences" element={<OffreFrequencesList />} />
        <Route path="/offreFrequences/:id" element={<OffreFrequenceDetail />} />
        <Route path="/offreSections" element={<OffreSectionsList />} />
        <Route path="/offreSections/:id" element={<OffreSectionDetail />} />
        <Route path="/offreTaches" element={<OffreTachesList />} />
        <Route path="/offreTaches/:id" element={<OffreTacheDetail />} />
        <Route path="/personnel" element={<PersonnelList />} />
        <Route path="/personnel/:id" element={<PersonnelDetail />} />
        <Route path="/personnel/:relatedId/temps" element={<Navigate to="./.." />} />
        <Route path="/personnel/:relatedId/temps/:id" element={<TempsDetail relation="personnelId" personnel />} />
        <Route path="/personnel/:relatedId/historique" element={<Navigate to="./.." />} />
        <Route path="/personnel/:relatedId/historique/:id" element={<HistoriqueDetail relation="personnelId" />} />
        <Route path="/personnel/controle" element={<PersonnelControle />} />
        <Route path="/travauxPonctuels" element={<TravauxPonctuelsList />} />
        <Route path="/travauxPonctuels/:id" element={<TravauxPonctuelsDetail />} />
        <Route path="/typeDePlaintes" element={<TypeDePlaintesList />} />
        <Route path="/typeDePlaintes/:id" element={<TypeDePlainteDetail />} />
        <Route path="/verreFrequence" element={<VerreFrequencesList />} />
        <Route path="/verreFrequence/:id" element={<VerreFrequenceDetail />} />
        <Route path="/societes" element={<SocietesList />} />
        <Route path="/societes/:id" element={<SocieteDetail />} />
        <Route path="/users" element={<UsersList />} />
        <Route path="/users/:id" element={<UserDetail />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="*" element={<ThrowNotFound />} />
    </RoutesContainer>
}